var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{attrs:{"id":"demo"}}),_c('div',{staticClass:"bottom_confirm"},[_c('div',{staticClass:"comfirm_btn",on:{"click":_vm.confirm}},[_vm._v("同意确认并支付电子合同款")])])])}
var staticRenderFns = []

export { render, staticRenderFns }